import { Component } from '@angular/core';

@Component({
    selector: 'app-ddk-spinner',
    templateUrl: 'ddk-spinner.component.html',
    styleUrls: ['ddk-spinner.component.scss']
})
export class DdkSpinnerComponent
{
    public constructor()
    {

    }
}
